import React from "react";
import { NavLink } from "react-router-dom";
import IndustryLeaders from "../../components/industry-leaders/industry-leaders";
import Testimonials from "../../components/home/Testimonials";
import hospitalityBanner from "../../assets/images/hospitality/hospitalityBanner.png";
import presizeAudTar from "../../assets/images/hospitality/precise-audi-targ.png";
import leadCapture from "../../assets/images/hospitality/leadCapture.png";
import multiChannel from "../../assets/images/hospitality/multi-chennal.png";
import automatedEmailCamp from "../../assets/images/hospitality/automated-email-camp.png";
import dynamicContentPers from "../../assets/images/hospitality/dynamic-content-perso.png";
import leadScoringPers from "../../assets/images/hospitality/leadScoringpers.png";
import onlineAdvert from "../../assets/images/hospitality/online-advert.png";
import socialMediaEngage from "../../assets/images/hospitality/socialMediaEngage.png";
import realTimeAna from "../../assets/images/hospitality/realTimeAna.png";
import increasedBooking from "../../assets/images/hospitality/inc-booking.svg";
import enhancedCampaign from "../../assets/images/hospitality/enhan-camp.svg";
import guestRel from "../../assets/images/hospitality/stronger-guest-rel.svg";
import dataDrivenMarketing from "../../assets/images/hospitality/data-driven-marketing-decision.svg";
import Cta from "../../components/cta/cta";
import driveDirectBooking from "../../assets/images/hospitality/drive-direct-bookings.png";

const HospitalityPage = () => {
  return (
    <>
      <div className="hospitalityWrapper">
        <section className="hospitalityBanner">
          <div className="max-container">
            <div className="padd-90">
              <div className="text-center">
                <h1 className="heading39px roboto-bold mb10 text-color-131415">
                  Drive More Bookings and Build Stronger <br /> Guest
                  Relationships with BeyondLeadz
                </h1>
                <p className="heading16px roboto-regular mb30 text-color-131415">
                  {" "}
                  BeyondLeadz: Targeted Marketing and Lead Generation for the
                  Hospitality Industry
                </p>

                <ul className="btn-sec mb40">
                  <li>
                    <NavLink
                      to={"/signup"}
                      className="common-btn-class main-btn-primary roboto-regular"
                    >
                      {" "}
                      Subscribe Now
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={"/contact-us"}
                      className="common-btn-class transparentBtn roboto-regular"
                    >
                      Contact us
                    </NavLink>
                  </li>
                </ul>

                <img
                  src={hospitalityBanner}
                  loading="lazy"
                  class="img-responsive position-relative"
                  alt="Instant Lead Capture"
                />
              </div>
            </div>
          </div>
        </section>

        <IndustryLeaders />

        <section className="_blank60px">&nbsp;</section>

        <section className="driveBookings">
          <div className="max-container">
            <div className="padd-90">
              <div className="grid-auto-fit align-items-center max-width950">
                <div>
                  <img
                    src={driveDirectBooking}
                    alt="Drive Direct Bookings Effortlessly"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h2 className="roboto-bold mb10 heading29px">
                    Drive Direct Bookings Effortlessly
                  </h2>
                  <p className="heading16px roboto-regular">
                    In the competitive hospitality industry, attracting and
                    retaining guests requires highly targeted marketing
                    strategies and effective lead generation. BeyondLeadz is
                    designed to help hotels, resorts, and travel businesses
                    reach the right audience, convert more leads, and enhance
                    guest loyalty through personalized marketing efforts.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold heading29px mb40 text-center">
                Marketing and Lead Generation <br /> Solutions for the
                Hospitality Industry
              </h2>
              <div
                className="grid-auto-fit align-items-center mb60 max-width950"
                style={{
                  padding: "20px",
                  backgroundColor: "#F8FCFF",
                  borderRadius: "32px",
                }}
              >
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Precision Audience Targeting
                  </h3>
                  <p className="heading16px roboto-regular">
                    BeyondLeadz allows you to segment your audience based on
                    specific criteria such as booking history, guest
                    preferences, and geographic location. By targeting these
                    segments with tailored campaigns, you can increase the
                    relevance of your messaging and boost engagement.
                  </p>
                </div>
                <div>
                  <img
                    src={presizeAudTar}
                    alt="Precision Audience Targeting"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
              </div>

              <div
                className="grid-auto-fit align-items-center mb60 max-width950"
                style={{
                  padding: "20px",
                  backgroundColor: "#F8FCFF",
                  borderRadius: "32px",
                }}
              >
                <div className="block-order2">
                  <img
                    src={leadCapture}
                    alt="Integrated Lead Capture from Booking Platforms"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Integrated Lead Capture from Booking Platforms
                  </h3>
                  <p className="heading16px roboto-regular">
                    Capture leads directly from popular booking sites like
                    MakeMyTrip, TripAdvisor, Hotels.com, and Booking.com.
                    BeyondLeadz automatically integrates these leads into your
                    marketing database, enabling you to follow up with
                    personalized offers and promotions.
                  </p>
                </div>
              </div>

              <div
                className="grid-auto-fit align-items-center mb60 max-width950"
                style={{
                  padding: "20px",
                  backgroundColor: "#F8FCFF",
                  borderRadius: "32px",
                }}
              >
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Multi-Channel Campaign Management
                  </h3>
                  <p className="heading16px roboto-regular">
                    Launch and manage marketing campaigns across various
                    channels, including email, social media, and SMS.
                    BeyondLeadz ensures consistent messaging across all
                    platforms, helping you reach potential guests wherever they
                    are most active.
                  </p>
                </div>
                <div>
                  <img
                    src={multiChannel}
                    alt="Multi-Channel Campaign Management"
                    className="img-responsive"
                  />
                </div>
              </div>

              <div
                className="grid-auto-fit align-items-center mb60 max-width950"
                style={{
                  padding: "20px",
                  backgroundColor: "#F8FCFF",
                  borderRadius: "32px",
                }}
              >
                <div className="block-order2">
                  <img
                    src={automatedEmailCamp}
                    alt="Automated Email Campaigns"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Automated Email Campaigns
                  </h3>
                  <p className="heading16px roboto-regular">
                    Set up automated email workflows to nurture leads throughout
                    their decision-making process. From welcome emails to
                    post-stay follow-ups, BeyondLeadz enables you to stay
                    connected with your guests, increasing the likelihood of
                    repeat bookings.
                  </p>
                </div>
              </div>

              <div
                className="grid-auto-fit align-items-center mb60 max-width950"
                style={{
                  padding: "20px",
                  backgroundColor: "#F8FCFF",
                  borderRadius: "32px",
                }}
              >
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Dynamic Content Personalization
                  </h3>
                  <p className="heading16px roboto-regular">
                    Leverage guest data to create personalized content and
                    offers that resonate with individual preferences. Whether
                    it’s a special discount for a returning guest or a tailored
                    package for a honeymoon couple, BeyondLeadz helps you
                    deliver messages that drive conversions.
                  </p>
                </div>
                <div>
                  <img
                    src={dynamicContentPers}
                    alt="Dynamic Content Personalization"
                    className="img-responsive"
                  />
                </div>
              </div>

              <div
                className="grid-auto-fit align-items-center mb60 max-width950"
                style={{
                  padding: "20px",
                  backgroundColor: "#F8FCFF",
                  borderRadius: "32px",
                }}
              >
                <div className="block-order2">
                  <img
                    src={leadScoringPers}
                    alt="Lead Scoring and Prioritization"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Lead Scoring and Prioritization
                  </h3>
                  <p className="heading16px roboto-regular">
                    Use lead scoring to identify and prioritize high-potential
                    guests. BeyondLeadz automatically assigns scores based on
                    interactions and behaviors, ensuring your marketing and
                    sales efforts are focused on leads with the highest
                    likelihood of booking.
                  </p>
                </div>
              </div>

              <div
                className="grid-auto-fit align-items-center mb60 max-width950"
                style={{
                  padding: "20px",
                  backgroundColor: "#F8FCFF",
                  borderRadius: "32px",
                }}
              >
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Online Advertising Integration
                  </h3>
                  <p className="heading16px roboto-regular">
                    Integrate BeyondLeadz with your Google Ads, Facebook, and
                    Instagram campaigns to capture leads from paid advertising.
                    Track the effectiveness of your ads in real-time and adjust
                    your strategies to maximize ROI.
                  </p>
                </div>
                <div>
                  <img
                    src={onlineAdvert}
                    alt="Online Advertising Integration"
                    className="img-responsive"
                  />
                </div>
              </div>

              <div
                className="grid-auto-fit align-items-center mb60 max-width950"
                style={{
                  padding: "20px",
                  backgroundColor: "#F8FCFF",
                  borderRadius: "32px",
                }}
              >
                <div className="block-order2">
                  <img
                    src={socialMediaEngage}
                    alt="Social Media Engagement"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Social Media Engagement
                  </h3>
                  <p className="heading16px roboto-regular">
                    Engage with potential guests on social media platforms like
                    Facebook and Instagram. BeyondLeadz helps you monitor
                    interactions, respond to inquiries, and capture leads
                    directly from social channels, turning social engagement
                    into tangible bookings.
                  </p>
                </div>
              </div>

              <div
                className="grid-auto-fit align-items-center max-width950"
                style={{
                  padding: "20px",
                  backgroundColor: "#F8FCFF",
                  borderRadius: "32px",
                }}
              >
                <div>
                  <h3 className="heading20px roboto-bold mb10">
                    Real-Time Analytics and Reporting
                  </h3>
                  <p className="heading16px roboto-regular">
                    Access detailed reports on campaign performance, lead
                    generation, and booking conversions. BeyondLeadz provides
                    you with the insights needed to refine your marketing
                    strategies, optimize your lead generation efforts, and
                    achieve better results.
                  </p>
                </div>
                <div>
                  <img
                    src={realTimeAna}
                    alt="Real-Time Analytics and Reporting"
                    className="img-responsive"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="benefits-for-marketing">
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb40 heading29px text-center">
                Benefits for Marketing and Lead <br /> Generation in the
                Hospitality Industry
              </h2>

              <div
                className="grid-auto-fit max-width950"
                style={{
                  "--grid-columns": "repeat(2, 1fr)",
                  "--grid-gap": "24px",
                }}
              >
                <div className="common-white-box common-shadow">
                  <img
                    src={increasedBooking}
                    className="img-responsive position-relative"
                    alt="Increased Direct Bookings"
                  />

                  <h3 className="roboto-bold heading20px mb10 mt20">
                    Increased Direct Bookings
                  </h3>
                  <p className="roboto-regular heading16px">
                    Capture and nurture leads effectively, driving more direct
                    bookings and reducing reliance on third-party booking
                    platforms.
                  </p>
                </div>

                <div className="common-white-box common-shadow">
                  <img
                    src={enhancedCampaign}
                    className="img-responsive position-relative"
                    alt="Enhanced Campaign ROI"
                  />

                  <h3 className="roboto-bold heading20px mb10 mt20">
                    Enhanced Campaign ROI
                  </h3>
                  <p className="roboto-regular heading16px">
                    Target the right audience with personalized marketing
                    efforts, improving engagement rates and maximizing the
                    return on your marketing spend.
                  </p>
                </div>

                <div className="common-white-box common-shadow">
                  <img
                    src={guestRel}
                    className="img-responsive position-relative"
                    alt="Stronger Guest Relationships"
                  />

                  <h3 className="roboto-bold heading20px mb10 mt20">
                    Stronger Guest Relationships
                  </h3>
                  <p className="roboto-regular heading16px">
                    Build long-term relationships with guests through
                    personalized communication and targeted offers, leading to
                    increased loyalty and repeat bookings.
                  </p>
                </div>

                <div className="common-white-box common-shadow">
                  <img
                    src={dataDrivenMarketing}
                    className="img-responsive position-relative"
                    alt="Data-Driven Marketing Decisions"
                  />

                  <h3 className="roboto-bold heading20px mb10 mt20">
                    Data-Driven Marketing Decisions
                  </h3>
                  <p className="roboto-regular heading16px">
                    Use real-time data to make informed decisions that enhance
                    the effectiveness of your marketing campaigns and lead
                    generation strategies.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Cta
          heading="Reach Your Ideal Customer With Us"
          firstCta="/signup"
          firstCtaText="Subscribe Now"
          secondCta="/contact-us"
          secondCtaText="Contact us"
        />

        <Testimonials />
      </div>
    </>
  );
};

export default HospitalityPage;
